import { render, staticRenderFns } from "./CurrencyDetail.vue?vue&type=template&id=1e4aa523&scoped=true&lang=html&"
import script from "./CurrencyDetail.vue?vue&type=script&lang=js&"
export * from "./CurrencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyDetail.vue?vue&type=style&index=0&id=1e4aa523&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4aa523",
  null
  
)

export default component.exports